import React from 'react';
import { MapPin, Stethoscope, Users, Clock } from 'lucide-react';
import { IITH, SANS } from './iithBrand';

export default function LandingTrustStrip({ primary, specialtyCount, doctorCount, address }) {
  const accent = primary || IITH.saffron;
  const items = [
    { Icon: MapPin, label: address || IITH.campus },
    { Icon: Stethoscope, label: `${specialtyCount || '—'} clinical specialties` },
    { Icon: Users, label: `${doctorCount || '—'} doctors & consultants` },
    { Icon: Clock, label: 'Online OPD booking · confirmation by hospital' },
  ];

  return (
    <section
      className="border-y border-white/10"
      style={{ background: `linear-gradient(90deg, ${IITH.ink}, ${IITH.navyMid})` }}
      data-testid="landing-trust-strip"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-6 py-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {items.map(({ Icon, label }) => (
          <div key={label} className="flex items-start gap-2.5 min-w-0">
            <Icon className="h-4 w-4 mt-0.5 flex-shrink-0" style={{ color: accent }} />
            <p className="text-[12px] text-[#E8EEF5]/85 leading-snug" style={{ fontFamily: SANS }}>
              {label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
